import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft, faArrowUp, faFlagCheckered, faLocationArrow } from '@fortawesome/free-solid-svg-icons';

/**
 * TurnCard - Pill turn-by-turn indication HUD card matching Figma Driving view
 */
export function TurnCard({ type = 'straight', instruction = 'Sigue derecho por la avenida', distance = '250 m' }) {
  const getIcon = () => {
    switch (type) {
      case 'left':
      case 'slight_left':
      case 'sharp_left':
        return faArrowLeft;
      case 'right':
      case 'slight_right':
      case 'sharp_right':
        return faArrowRight;
      case 'arrive':
        return faFlagCheckered;
      case 'straight':
        return faArrowUp;
      default:
        return faLocationArrow;
    }
  };

  const isArrive = type === 'arrive';

  return (
    <div className="flex items-center justify-between p-3.5 bg-black/90 backdrop-blur-xl border border-gray-800/80 rounded-2xl shadow-2xl transition-all">
      <div className="flex items-center gap-3 min-w-0 flex-1 mr-2">
        <div className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 border ${
          isArrive 
            ? 'bg-emerald-500/20 text-emerald-400 border-emerald-500/40 shadow-[0_0_12px_rgba(34,197,94,0.3)]' 
            : 'bg-[var(--bry-accent)]/20 text-[var(--bry-accent)] border-[var(--bry-accent)]/40 shadow-[0_0_12px_rgba(14,171,176,0.3)]'
        }`}>
          <FontAwesomeIcon icon={getIcon()} className="text-lg" />
        </div>
        <div className="min-w-0 flex-1">
          <span className="block text-xs uppercase font-bold tracking-wider text-gray-400">Próximo Giro</span>
          <span className="block text-sm font-bold text-white truncate leading-tight">{instruction}</span>
        </div>
      </div>
      <span className="text-sm font-extrabold text-[var(--bry-accent)] bg-[var(--bry-accent)]/15 px-3 py-1.5 rounded-full border border-[var(--bry-accent)]/30 shrink-0">
        {distance}
      </span>
    </div>
  );
}

export default TurnCard;

